export const searchIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="m23.414 20.591-4.645-4.645a10.256 10.256 0 1 0-2.828 2.829l4.645 4.644a2.025 2.025 0 0 0 2.828 0 2 2 0 0 0 0-2.828M10.25 3.005A7.25 7.25 0 1 1 3 10.255a7.26 7.26 0 0 1 7.25-7.25"/></svg>`,
    name: 'search'
};